package com.eladfinish.bible.contest.features.hebrewCalendar

import com.eladfinish.bible.contest.extensions.replaceRegex
import sternbach.software.kosherkotlin.hebrewcalendar.HebrewDateFormatter
import sternbach.software.kosherkotlin.hebrewcalendar.JewishCalendar

class GetTodayHebrewDateUseCase {

    operator fun invoke(): String {
        val jewishCalendar = JewishCalendar().apply {
            inIsrael = true // todo: check if user is in Israel
        }
        val hdf = HebrewDateFormatter().apply {
            isHebrewFormat = true
            isUseLongHebrewYears = true
        }

        return hdf.format(jewishCalendar)
            .replaceRegex(regex = "׳\\s(\\S+)״", replacement = "׳$1״")
            .replaceRegex(regex = "׳", replacement = "'").replace("״", "\"")
    }

}
